import React, { useState, useEffect, useMemo } from 'react';
import DataGrid from '../../../../Core/Controls/Grid/index';
import { AddButton, EditButton, BreadCrumbs } from '../../../../Core/Controls';
import DialogBox from './collectionNDeliveryDialog';
import { useToast } from '../../../../Core/Hooks/useToast';
import DialogComp from '../../../../Core//Dialog/DialogComp';
import '../../../commonStyle.scss';
import GijgoGrid from '../../../../Core/Controls/GijgoGrid';

import { getAllCollectionNDelivery, postCollectionNDelivery } from '../../../../Core/Services/InternalUser/collectionNDeliveryService';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Jobs', active: true },
    { name: 'Collection And Deliveries', active: true }
];
const basecolumns = [
    { key: 'action', name: 'Action', width: '5%' },
    { key: 'collectionAndDeliverDescription', name: 'Description' }
];
const BookingDelayReason = () => {
    const [state, setState] = useState({
        open: false,
        showLoader: true,
        selectedRowData: {}
    });
    const { showToastSuccess, showToastError } = useToast();

    useEffect(async () => {
        pullApiData();
    }, []);

    const pullApiData = async () => {
        setState((state) => ({
            ...state,
            isReload: new Date()
        }));
    };
    const renderEdit = (ev, row) => {
        return (
            <div
                style={{
                    textAlign: 'center'
                }}
            >
                <EditButton
                    toolTipTitle="Edit Collection And Delivery"
                    onClick={() => {
                        setState((st) => ({
                            ...st,
                            open: true,
                            title: 'Edit Collection And Delivery',
                            selectedRowData: row,
                            isAdd: false
                        }));
                    }}
                />
            </div>
        );
    };
    const columns = useMemo(() => {
        const tempCols = [...basecolumns];
        let actionCol = tempCols.find((e) => e.key === 'action');
        if (actionCol) {
            actionCol.formatter = renderEdit;
        }
        return tempCols;
    }, []);

    const saveData = async (outData) => {
        let response = await postCollectionNDelivery({
            collectionAndDeliverID: outData.id || null,
            collectionAndDeliverDescription: outData.value
        });
        if (response) {
            response.success
                ? showToastSuccess(state.isAdd ? 'Collection And Delivery added successfully' : 'Collection And Delivery updated successfully')
                : showToastError(response.message || 'Something went wrong');
        } else {
            showToastError('Something went wrong');
        }
        pullApiData();
    };
    const addBtnClicked = () => {
        setState((st) => ({
            ...st,
            open: true,
            title: 'Add Collection And Delivery',
            isAdd: true,
            selectedRowData: {}
        }));
    };
    const handleClose = () => {
        setState((st) => ({
            ...st,
            open: false
        }));
    };
    return (
        <div className="screen">
            <BreadCrumbs crumbs={crumbs} />
            <GijgoGrid
                columns={columns}
                getUrl="CollectionAndDelivery"
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                isReload={state.isReload}
                btnTitle="Add Collection And Delivery"
                onBtnClick={addBtnClicked}
            />
            {state.open ? (
                <DialogComp open={state.open} onClose={handleClose} title={state.title} maxWidth="md">
                    <DialogBox data={state} onClose={handleClose} saveData={saveData} />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default BookingDelayReason;
